/* Simple Billing API client with JWT handling */
const DEFAULT_BASE_URL = `${process.env.REACT_APP_BILLING_URL}`.replace("/api/v1/", "");

let authToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdXRob3JpemVkIjp0cnVlLCJlbWFpbCI6ImFkbWluQGV4YW1wbGUuY29tIiwiZXhwIjoxNzYxMDI1NTM2fQ.y7WUjAtNuBJKE9eyxSdjQg-o4NV8TI7hRXMS2gcMRTE";
let baseUrl = DEFAULT_BASE_URL;

export const setBillingBaseUrl = (url) => {
  baseUrl = url || DEFAULT_BASE_URL;
};

export const setBillingAuthToken = (token) => {
  authToken = token;
};

export const loginBilling = async ({ email, password }) => {
  const res = await fetch(`${baseUrl}/api/v1/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  if (!res.ok) throw new Error('Billing login failed');
  const data = await res.json();
  authToken = data?.token || data?.access_token || null;
  return authToken;
};

const request = async (path, { method = 'GET', body } = {}) => {
  const headers = { 'Content-Type': 'application/json' };
  if (authToken) headers.Token = authToken;
  const res = await fetch(`${baseUrl}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Request failed: ${res.status}`);
  }
  const contentType = res.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) return res.json();
  return res.text();
};

// Feature APIs
export const apiInsertFeature = (payload) => request('/api/v1/prov/insertFeature', { method: 'POST', body: payload });
export const apiUpdateFeature = (payload) => request('/api/v1/prov/updateFeature', { method: 'POST', body: payload });
export const apiSelectFeatures = () => request('/api/v1/prov/selectFeatures');
export const apiDeleteFeature = (payload) => request('/api/v1/prov/deleteFeature', { method: 'POST', body: payload });

// Feature Rate APIs
export const apiInsertFeatureRate = (payload) => request('/api/v1/prov/insertFeatureRate', { method: 'POST', body: payload });
export const apiUpdateFeatureRate = (payload) => request('/api/v1/prov/updateFeatureRate', { method: 'POST', body: payload });
export const apiSelectFeatureRates = () => request('/api/v1/prov/selectFeatureRates');
export const apiDeleteFeatureRate = (payload) => request('/api/v1/prov/deleteFeatureRate', { method: 'POST', body: payload });
export const apiGetAvailableFeatures = (subscriberId, options = {}) => {
  const params = new URLSearchParams();
  if (subscriberId) params.set('subscriber_id', String(subscriberId));
  if (options.subscriberOnly) params.set('subscriber_only', 'true');
  const qs = params.toString() ? `?${params.toString()}` : '';
  return request(`/api/v1/prov/getAvailableFeatures${qs}`);
};

// Base Package APIs (deprecated — features are independent; kept for rollback)
export const apiInsertBasePackage = (payload) => request('/api/v1/prov/insertBasePackage', { method: 'POST', body: payload });
export const apiUpdateBasePackage = (payload) => request('/api/v1/prov/updateBasePackage', { method: 'POST', body: payload });
export const apiSelectBasePackages = () => request('/api/v1/prov/selectBasePackages');
export const apiGetBasePackageByName = (name) => request(`/api/v1/prov/getBasePackage/${encodeURIComponent(name)}`);
export const apiGetBasePackageFeatures = (id) => request(`/api/v1/prov/getBasePackageFeatures/${id}`);

// Feature-Package junction
export const apiAddFeatureToPackage = (payload) => request('/api/v1/prov/addFeatureToPackage', { method: 'POST', body: payload });
export const apiRemoveFeatureFromPackage = (payload) => request('/api/v1/prov/removeFeatureFromPackage', { method: 'POST', body: payload });
export const apiActivateFeatureInPackage = (payload) => request('/api/v1/prov/activateFeatureInPackage', { method: 'POST', body: payload });
export const apiGetPackageWithFeatures = (id) => request(`/api/v1/prov/getPackageWithFeatures/${id}`);

// Account activation
export const apiActivatePackage = (payload) => request('/api/v1/prov/activatePackage', { method: 'POST', body: payload });
export const apiDeactivatePackage = (payload) => request('/api/v1/prov/deactivatePackage', { method: 'POST', body: payload });
export const apiGetActivePackages = (accountId) => request(`/api/v1/prov/getActivePackages/${accountId}`);
export const apiActivateFeature = (payload) => request('/api/v1/prov/activateFeature', { method: 'POST', body: payload });
export const apiDeactivateFeature = (payload) => request('/api/v1/prov/deactivateFeature', { method: 'POST', body: payload });
export const apiGetActiveFeatures = (accountId) => request(`/api/v1/prov/getActiveFeatures/${accountId}`);

// Bulk activation
export const apiActivateMultipleFeatures = (payload) => request('/api/v1/prov/activateMultipleFeatures', { method: 'POST', body: payload });
export const apiActivateMultiplePackages = (payload) => request('/api/v1/prov/activateMultiplePackages', { method: 'POST', body: payload });

// Payment History
export const apiGetSubscriberPaymentHistory = (payload) => request('/api/v1/prov/get-subscriber-payment-history', { method: 'POST', body: payload });

// Card / payment method management
export const apiListPaymentMethods = (payload) => request('/api/v1/prov/stripe/list-payment-methods', { method: 'POST', body: payload });
export const apiDetachPaymentMethod = (payload) => request('/api/v1/prov/stripe/detach-payment-method', { method: 'POST', body: payload });
export const apiSetDefaultPaymentMethod = (payload) => request('/api/v1/prov/stripe/set-default-payment-method', { method: 'POST', body: payload });
export const apiAttachPaymentMethod = (payload) => request('/api/v1/prov/stripe/attach-payment-method', { method: 'POST', body: payload });
export const apiCreateCustomerSetupIntent = (payload) => request('/api/v1/prov/stripe/create-customer-setup-intent', { method: 'POST', body: payload });


